module.exports = __webpack_public_path__ + "img/side_home.944109f7.png";